export const baseURL = 'http://agrorecon-api.herokuapp.com/';
export const imgbaseURL = 'http://agrorecon-api.herokuapp.com';